import React, { Component } from "react";
import PropTypes from "prop-types";

// Material UI
import {
  withStyles,
  Button,
  Grid,
  Typography,
  TextField,
  LinearProgress,
} from "@material-ui/core";

// Layout
import { Dashboard as DashboardLayout } from "layouts";

// Firebase
import firebase from "firebase";
import FileUploader from "react-firebase-file-uploader";
import { firestore_db } from "../../config/firebase_config";

const styles = (theme) => ({
  root: {
    padding: theme.spacing.unit * 4,
  },
  content: {
    padding: "15px",
    "& .MuiPaper-elevation2": {
      boxShadow: "none",
      border: "1px solid #dfe3e8",
      borderBottom: "none",
    },
  },
});

class Apks extends Component {
  state = {
    isUploading: false,
    imageUploadProgress: 0,

    trivision: {
      version: "",
      apk_url: "",
      is_mandatory: false,
    },

    masti: {
      version: "",
      apk_url: "",
      is_mandatory: false,
    },
  };

  // ---------- Generic Upload Handlers ----------

  handleUploadStart = () => {
    this.setState({ isUploading: true, imageUploadProgress: 0 });
  };

  handleUploadProgress = (progress) => {
    this.setState({ imageUploadProgress: progress });
  };

  handleUploadError = () => {
    this.setState({ isUploading: false });
  };

  handleUploadSuccess = async (fileName, type) => {
    try {
      const url = await firebase
        .storage()
        .ref("Apks")
        .child(fileName)
        .getDownloadURL();

      this.setState((prev) => ({
        isUploading: false,
        imageUploadProgress: 100,
        [type]: {
          ...prev[type],
          apk_url: url,
        },
      }));
    } catch (error) {
      console.error(error);
      this.setState({ isUploading: false });
    }
  };

  // ---------- Submit ----------

  submitApk = async (type, docName) => {
    const data = this.state[type];

    if (!data.version || !data.apk_url) {
      alert("Please upload APK and enter version.");
      return;
    }

    try {
      var fieldName = type === 'masti'?'masti_is_mandatory':'type_is_mandatory';
      await firestore_db
        .collection("apks")
        .doc(docName)
        .set({
          apk_url: data.apk_url,
          version: data.version,
          [fieldName]: data.is_mandatory,
        });

      alert(`APK uploaded successfully (${data.version})`);

      this.setState((prev) => ({
        [type]: {
          ...prev[type],
          version: "",
          apk_url: "",
          type_is_mandatory: false,
        },
      }));
    } catch (error) {
      console.error(error);
    }
  };

  // ---------- Render Helper ----------

  renderApkSection = ({ title, type, fileName, label, submitDoc }) => {
    const data = this.state[type];

    return (
      <Grid justify="center" spacing={4} className={this.props.classes.content}>
        <label style={stylesLabel}>{title}</label>

        <TextField
          fullWidth
          variant="outlined"
          label={label}
          value={data.version}
          onChange={(e) =>
            this.setState({
              [type]: { ...data, version: e.target.value },
            })
          }
          style={{ margin: "10px 10px 20px 10px" }}
        />
        <div style={{ margin: "10px 10px 20px 10px" }}>
          <Grid container spacing={2} alignItems="stretch">
            {/* APK URL Field */}
            <Grid item xs={7}>
              <TextField
                fullWidth
                variant="outlined"
                label="APK URL"
                value={data.apk_url}
                onChange={(e) =>
                  this.setState({
                    [type]: {
                      ...data,
                      apk_url: e.target.value,
                    },
                  })
                }
              />
            </Grid>

            {/* Select APK Button */}
            <Grid item xs={3}>
              <label
                style={{ width: "100%", height: "100%", cursor: "pointer" }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  disableElevation
                  component="span"
                  style={{
                    height: "56px",
                    textTransform: "none",
                    fontWeight: 600,
                    boxShadow: "none",
                  }}
                >
                  Select APK
                </Button>

                <FileUploader
                  hidden
                  accept="*"
                  filename={fileName}
                  storageRef={firebase.storage().ref("Apks")}
                  onUploadStart={this.handleUploadStart}
                  onUploadError={this.handleUploadError}
                  onUploadSuccess={() =>
                    this.handleUploadSuccess(fileName, type)
                  }
                  onProgress={this.handleUploadProgress}
                />
              </label>
            </Grid>

            {/* Mandatory Checkbox */}
            <Grid item xs={2} style={{ display: "flex", alignItems: "center" }}>
              <label
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <input
                  type="checkbox"
                  checked={this.state.is_mandatory}
                  onChange={(e) =>
                    this.setState({
                    [type]: {
                      ...data,
                      is_mandatory: e.target.checked
                    },
                  })
                  }
                />
                Mandatory
              </label>
            </Grid>
          </Grid>
        </div>

        <Button
          variant="contained"
          color="secondary"
          fullWidth
          disableElevation
          onClick={() => this.submitApk(type, submitDoc)}
          style={{
            height: "56px", // same as TextField & Select button
            width: "100%",
            textTransform: "none",
            fontWeight: 600,
            boxShadow: "none",
          }}
        >
          Submit
        </Button>
      </Grid>
    );
  };

  render() {
    return (
      <DashboardLayout title="Apks">
        {this.renderApkSection({
          title: "Trivision TV",
          type: "trivision",
          fileName: "Apk.apk",
          label: "Version",
          submitDoc: "apk",
        })}

        {this.renderApkSection({
          title: "Masti TV",
          type: "masti",
          fileName: "Masti_TV.apk",
          label: "Masti Tv Apk Version",
          submitDoc: "masti_apk",
        })}
      </DashboardLayout>
    );
  }
}

// ---------- Styles ----------
const stylesLabel = {
  color: "#000",
  fontSize: "30px",
  fontWeight: 600,
  marginTop: "50px",
  paddingBottom: "50px",
};

const uploadLabel = {
  cursor: "pointer",
  margin: "auto",
};

const uploadButton = {
  color: "#fff",
  padding: "10px",
  background: "#0000ff6b",
  borderRadius: "10px",
  width: "fit-content",
};

Apks.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Apks);
